/* ==========================================================================
   Virsaay — Festive Garden USP Scroll Stack Controller
   Pins the Festive Garden banner while 3 physical USP cards sequentially
   rise and stack on top of each other on scroll.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Wait for VirsaayMotion the same way virsaay-usp-stack.js does
     ------------------------------------------------------------------ */
  function waitForMotion(callback) {
    if (window.VirsaayMotion && window.VirsaayMotion.ready) {
      window.VirsaayMotion.ready(callback);
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (window.VirsaayMotion && window.VirsaayMotion.ready) {
        clearInterval(timer);
        window.VirsaayMotion.ready(callback);
      } else if (attempts > 60) {
        clearInterval(timer);
        if (window.gsap && window.ScrollTrigger) {
          callback(window.gsap, window.ScrollTrigger);
        }
      }
    }, 50);
  }

  function initFestiveBanner(section) {
    if (!section || section.dataset.vfubInitialized === 'true') return;
    section.dataset.vfubInitialized = 'true';

    var cards = section.querySelectorAll('[data-usp-card]');
    if (!cards.length) return;

    var cardList = Array.prototype.slice.call(cards);
    var stage = section.querySelector('[data-festive-stage]') || section;

    waitForMotion(function (gsap, ScrollTrigger) {
      if (!gsap || !ScrollTrigger) return;
      if (window.VirsaayMotion && window.VirsaayMotion.reduced) {
        gsap.set(cardList, { yPercent: 0, opacity: 1, scale: 1 });
        return;
      }

      gsap.registerPlugin(ScrollTrigger);

      var ctx = gsap.context(function () {
        // Initial state: cards start below view
        gsap.set(cardList, {
          yPercent: 130,
          opacity: 0,
          scale: 1,
          transformOrigin: 'center top',
          force3D: true
        });

        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: 'top top',
            end: '+=320%',
            pin: true,
            pinSpacing: true,
            scrub: 0.8,
            anticipatePin: 1,
            invalidateOnRefresh: true
          }
        });

        // Sequence all 3 cards sequentially
        cardList.forEach(function (card, index) {
          // Card enters from below
          tl.to(card, {
            yPercent: 0,
            opacity: 1,
            duration: 1.4,
            ease: 'power2.out'
          });

          // Previous cards recede into background stack
          if (index > 0) {
            var prevCards = cardList.slice(0, index);
            prevCards.forEach(function (prevCard, prevIndex) {
              var depth = index - prevIndex;
              tl.to(prevCard, {
                scale: Math.max(0.86, 1 - (depth * 0.06)),
                y: -(depth * 18),
                opacity: Math.max(0.32, 1 - (depth * 0.34)),
                rotation: (prevIndex % 2 === 0 ? -0.8 : 0.8) * depth,
                duration: 1.4,
                ease: 'power2.out'
              }, '<');
            });
          }

          // Settled pause on each card
          tl.to({}, { duration: 0.45 });
        });

        // Final hold so Card 3 stays fully visible and readable at top of stack before unpinning
        tl.to({}, { duration: 0.9 });

      }, section);

      // Refresh triggers once the loader completes and reveals layout
      if (window.VirsaayMotion && window.VirsaayMotion.on) {
        window.VirsaayMotion.on('loader:done', function () {
          ScrollTrigger.refresh();
        });
      }

      window.addEventListener('load', function () {
        ScrollTrigger.refresh();
      }, { once: true });

      // Register for cleanup
      if (window.VirsaayMotion && window.VirsaayMotion.register) {
        var st = ScrollTrigger.getAll().pop();
        if (st) window.VirsaayMotion.register(section, st);
      }

      section._vfubCtx = ctx;
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-festive-usp-banner]');
    for (var i = 0; i < sections.length; i++) {
      initFestiveBanner(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Theme Editor support
  document.addEventListener('shopify:section:load', function (evt) {
    var el = evt.target.querySelector('[data-festive-usp-banner]') || evt.target;
    if (el && el.hasAttribute('data-festive-usp-banner')) {
      el.dataset.vfubInitialized = '';
      initFestiveBanner(el);
    }
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    var el = evt.target.querySelector('[data-festive-usp-banner]') || evt.target;
    if (el && el._vfubCtx) el._vfubCtx.revert();
  });
})();
